module.exports = __webpack_public_path__ + "static/media/inventory-default-image.5600934d.png";